module.exports = __webpack_public_path__ + "static/media/clock.3996c740.svg";